export default __webpack_public_path__ + "static/media/Tiger's Legguards of Crouching Calm.624af85c.jpg";